import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { Breadcrumb } from './breadcrumb';
import EnBreadcrumbItem from './EnBreadcrumbItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnBreadcrumbs',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t } = useI18n();
        const router = useRouter();
        const defaultBreadcrumb = ref(new Breadcrumb(t('common.dashboard.title'), '/'));
        const shouldAddDefaultBreadcrumb = ref(false);
        router.afterEach(() => {
            updateShouldAddBreadcrumb();
        });
        function updateShouldAddBreadcrumb() {
            shouldAddDefaultBreadcrumb.value = window.location.pathname !== '/';
        }
        updateShouldAddBreadcrumb();
        const __returned__ = { t, router, defaultBreadcrumb, shouldAddDefaultBreadcrumb, updateShouldAddBreadcrumb, EnBreadcrumbItem };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
